import TestInfo from '../../../../../../../../Models/TestInfo';
import TestSelectionFormFieldNames from '../../../../../../Models/TestSelectionFormFieldNames';
import BaseTestCard from '../BaseTestCard/BaseTestCard';
import { PreviewQuestionsProps } from '../PreviewQuestions/Dialog/usePreviewQuestions';
import { resourceBaseUrl } from '@/AppSettings';
import UIStrings from '@/Utils/UIStrings';

interface PersonalityTestCardProps extends Omit<PreviewQuestionsProps, 'testType'> {
    test: TestInfo;
}

function PersonalityTestCard({ test, demoQuestions, likertOptions }: PersonalityTestCardProps) {
    return (
        <BaseTestCard
            {...test}
            testName={UIStrings.Personality}
            fieldName={TestSelectionFormFieldNames.isPersonalitySelected}
            imageURL={`${resourceBaseUrl}/images/Personality.png`}
            demoQuestions={demoQuestions}
            likertOptions={likertOptions}
        />
    );
}

export default PersonalityTestCard;
